<template>
  <div>
    <div class="vx-row">



      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col w-full mb-base">
        <vx-card title="">
          <div class="vx-row">
            <div class="vx-col sm:w-1/4 w-full mb-1"><v-select :value="program" v-model="program"
                :options="formatOptions"></v-select></div>
            <div class="vx-col sm:w-1/4 w-full mb-1">
              <datepicker :format="format" v-model="baslangic"></datepicker>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-1">
              <datepicker :format="format" v-model="bitis"></datepicker>
            </div>
            <div class="vx-col sm:w-1/4 w-full mb-1"><vs-button color="success" @click="satisListesi()"
                type="filled">Listele</vs-button></div>
          </div>





        </vx-card>

        <vs-table :data="data">
          <template slot="thead">

            <vs-th>Stok Kodu</vs-th>
            <vs-th>Stok Adı</vs-th>
            <vs-th sort-key="satisAdet">Satış Adet</vs-th>


          </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                {{ data[indextr].stokKodu }}
              </vs-td>

              <vs-td>
                {{ data[indextr].productName }}
              </vs-td>
              <vs-td>


                {{ data[indextr].satisAdet }}
              </vs-td>

            </vs-tr>
            <vs-tr>
              <vs-td></vs-td>
              <vs-td>Toplam</vs-td>
              <vs-td>{{ toplama() }}</vs-td>
            </vs-tr>
          </template>

        </vs-table>

      </div>


    </div>



  </div>
</template>



<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import state from '../../store/state'
import Store from '../../store/store'
export default {
  data() {
    return {
      format: "yyyy-MM-dd",
      data: [],
      baslangic: '',
      formattedDate: '',
      formattedDate1: '',
      bitis: '',
      toplam: 0,
      program: { id: 0, label: 'Pazaryeri' },
      check3: '',
      formatOptions: [],
    }
  },
  created() {
    this.tabList = Store.state.uzum.menuListForTabs;
    this.tabList.forEach((val, index) => {
      this.formatOptions.push({ label: val.name, id: val.name })
    });
  }, methods: {
    toplama() {
      var vm = this
      var sayi = 0
      this.data.forEach(element => {
        sayi = sayi + parseInt(element.satisAdet)
      });
      return sayi
      // this.toplam=parseInt(this.toplam)+parseInt(d)
      // return this.toplam
      //console.log(this.toplam)
    },
    satisListesi() {
      var vm = this

      const soap = require('soap')
      const url = state.sistemAddress

      var d = new Date(vm.baslangic);
      vm.formattedDate = d.getUTCFullYear() + "-" + (d.getUTCMonth() + 1) + "-" + d.getUTCDate();
      console.log(vm.formattedDate)
      var d1 = new Date(vm.bitis);
      vm.formattedDate1 = d1.getUTCFullYear() + "-" + (d1.getUTCMonth() + 1) + "-" + d1.getUTCDate();
      console.log(vm.formattedDate1)
      const args = { program: this.program.label, baslik: 'stokRaporu', tarih1: vm.formattedDate, tarih2: vm.formattedDate1, token: Store.state.tokenId }
      console.log(args)
      soap.createClient(url, function (err, client) {
        client.stokRaporu(args, function (err, result) {
          if (result.stokRaporuResult == '-1') {
            Store.dispatch('logout')
          }
          console.log(result.stokRaporuResult)
          vm.veriler = JSON.parse(result.stokRaporuResult)
          console.log(vm.veriler)
          vm.data = vm.veriler
          // vm.eslesenStokListesi=vm.veriler





        })
      })
    },
  },
  components: {
    'v-select': vSelect,
    Datepicker
  }
}
</script>
